const DashboardLine = ({ location }) => {
  return <div className={`dashboard-line ${location || ''}`} />;
};

export default DashboardLine;
